import {
  AssignmentTurnedIn,
  BusinessCenter,
  Dashboard,
  FilePresent,
  Warehouse,
  AdminPanelSettings,
} from "@mui/icons-material";
import * as perm from "../global-const/permissionName";

const sidebarConfig = [
  {
    title: "Dashboard",
    path: "/impex/dashboard",
    icon: <Dashboard />,
    accessorsRole: [
      perm.ImpexAdmin,
      perm.ImpexFinance,
      perm.ImpexOperations,
      perm.SupplierFinance,
      perm.SupplierOperations,
      perm.SupplierAdmin,
      perm.SuperAdmin,
    ],
  },
  {
    title: "Purchase Orders",
    path: "/impex/purchase-orders/list",
    icon: <BusinessCenter />,
    accessorsRole: [
      perm.ImpexAdmin,
      perm.ImpexFinance,
      perm.ImpexOperations,
      perm.SupplierFinance,
      perm.SupplierOperations,
      perm.SupplierAdmin,
      perm.SuperAdmin,
    ],
  },
  {
    title: "Goods Received Note",
    path: "/impex/good-received-note/list",
    icon: <Warehouse />,
    accessorsRole: [
      perm.ImpexAdmin,
      perm.ImpexFinance,
      perm.ImpexOperations,
      perm.SupplierFinance,
      perm.SupplierOperations,
      perm.SupplierAdmin,
      perm.SuperAdmin,
    ],
  },
  {
    title: "Quality Check",
    path: "/impex/quality-check/list",
    icon: <AssignmentTurnedIn />,
    accessorsRole: [
      perm.ImpexAdmin,
      perm.ImpexFinance,
      perm.ImpexOperations,
      perm.SupplierFinance,
      perm.SupplierOperations,
      perm.SupplierAdmin,
      perm.SuperAdmin,
    ],
  },
  {
    title: "Invoices",
    path: "/impex/invoices",
    icon: <FilePresent />,
    accessorsRole: [
      perm.ImpexAdmin,
      perm.ImpexFinance,
      perm.ImpexOperations,
      perm.SupplierFinance,
      perm.SupplierOperations,
      perm.SupplierAdmin,
      perm.SuperAdmin,
    ],
  },
  {
    title: "Impex Admin",
    path: "/impex/admin",
    icon: <AdminPanelSettings />,
    accessorsRole: [perm.ImpexAdmin, perm.SupplierAdmin, perm.SuperAdmin],
  },
];

export default sidebarConfig;
